import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: process.env.CLIENT_ID, 
        authority: "https://login.microsoftonline.com/18a59a81-eea8-4c30-948a-d8824cdc2580", 
        redirectUri: process.env.REACT_APP_REDIRECT_URI, 
      },
  cache: {
    cacheLocation: "localStorage", 
    storeAuthStateInCookie: false, 
  }
};

export const loginRequest = {
    scopes: ["User.Read", "email" ,"openid", "profile", "User.Read.All"],
};

export const scopeRequest = {
    scopes: ["api://Generative_Flow_Network_API.lilly.com/.default"],
};

export const tokenRequest = {
    scopes: ["User.Read", "email" ,"openid", "profile", "User.Read.All"],
  };

export const msalInstance = new PublicClientApplication(msalConfig);
